import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

import './waypointLazyRender.scss';

export const WaypointLazyRender = (props) => {
    const {
        initialIsVisible = false,
        emptyStateStyles = { height: '100px' },
        bottomOffset = '-100px',
    } = props;
    const [isVisible, setIsVisible] = React.useState(initialIsVisible);

    return (
        <Waypoint
            scrollableAncestor={'window'}
            bottomOffset={bottomOffset}
            onEnter={() => {
                setIsVisible(true);
            }}
        >
            <div
                className={`waypoint-lazy-render ${
                    isVisible ? 'waypoint-lazy-render--visible' : ''
                }`}
            >
                {isVisible ? props.children : <div style={emptyStateStyles} />}
            </div>
        </Waypoint>
    );
};

WaypointLazyRender.propTypes = {
    initialIsVisible: PropTypes.bool,
    emptyStateStyles: PropTypes.object,
    bottomOffset: PropTypes.string,
    onIsVisible: PropTypes.func,
};
